module.exports = __webpack_public_path__ + "static/media/myaniture.4bdd5412.png";